import request from '../../services/request';

export const getBillingInfo = (id) => {
  return request({
    url: `/company/${id}/billing-information`,
    method: 'GET',
  });
};

export function updateBillingInfo(id, data) {
  return request({
    url: `/company/${id}/billing-information`,
    method: 'PUT',
    data,
  });
}

// -------------- Catalogos ------------------------

export function catalogTaxRegimes() {
  return request({
    url: `/company/catalog/cfdi/regimes`,
    method: 'GET',
  });
}

export function catalogCFDI() {
  return request({
    url: `/company/catalog/cfdi/uses`,
    method: 'GET',
  });
}

export function catalogCountries() {
  return request({
    url: `/company/catalog/global/country`,
    method: 'GET',
  });
}

export function catalogStates(data) {
  return request({
    url: `/company/catalog/global/state`,
    method: 'POST',
    data,
  });
}

export function catalogCities(data) {
  return request({
    url: `/company/catalog/global/city`,
    method: 'POST',
    data,
  });
}
